import * as Msal from "@azure/msal-browser";
import { store } from ".";
import UrlHelper from "./utils/UrlHelpler";

export interface IUserAuthenticator {
  GetToken(): Promise<string>;
  IsAuthenticated(): Promise<boolean>;
}

export class UserAuthenticator implements IUserAuthenticator {

  public async GetToken(): Promise<string> {
    const sessionState = store.getState().sessionState;
    const activeAccount = sessionState.authClient?.getActiveAccount();
    const allAccounts = sessionState.authClient?.getAllAccounts();
    const silentRequest: Msal.SilentRequest = {
      scopes: sessionState.appRegistration?.scopes ?? [],
      redirectUri: UrlHelper.loginUrl(),
      account: activeAccount ?? (allAccounts?.length ?? 0) > 0 ? allAccounts![0] : undefined,
    };
    return await sessionState.authClient!
      .acquireTokenSilent(silentRequest)
      .then((result) => {
        if (result.accessToken) {
          return Promise.resolve(result.accessToken);
        }
        console.error("No access token retrieved");
        return "";
      })
      .catch(async (error) => {
        console.error("[auth.ts] Error acquireTokenSilent.", error);
        if (error instanceof Msal.InteractionRequiredAuthError) {
          try {
            // Return a rejected promise after redirect to prevent further execution
            await sessionState.authClient!.acquireTokenRedirect(silentRequest);
            return Promise.reject(new Error("[auth.ts] Redirecting for authentication"));
          } catch (redirectError) {
            console.error("[auth.ts] Error acquireTokenRedirect.", redirectError);
            return Promise.reject(redirectError);
          }
        }
        
        return Promise.reject("[auth.ts] Error acquiring the access token: " + error);
      });
  }

  public async IsAuthenticated(): Promise<boolean> {
    return await this.GetToken()
      .then(() => {
        return Promise.resolve(true);
      })
      .catch(() => {
        return Promise.resolve(false);
      });
  }
}
